export const productPdf = "" +
  "mutation productPdf($sku: String!) {" +
  "productPdf(sku: $sku) {status response file_name}" +
  "}";

